// extracted by mini-css-extract-plugin
export var container = "_a1-0";
export var error = "_a1-9";
export var label = "_a1-5";
export var light = "_a1-6";
export var md = "_a1-3";
export var sm = "_a1-2";
export var thin = "_a1-8";
export var thinBold = "_a1-7";
export var vertical = "_a1-4";
export var xs = "_a1-1";